import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { TableCell } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { InstagramStoryPost, InstagramStoryPostSortField } from '@anytag/graphql';

export const useInfluencerInstagramStoryPostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<InstagramStoryPost>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Story Post'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.content || ''}
          thumbnail={row.original.thumbnail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'impressions',
      header: t<string>('HeaderColumn.Impression'),
      meta: { align: 'right', help: t<string>('Tooltip.ImpsHelp'), sortField: InstagramStoryPostSortField.IMPRESSIONS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.impressions)} />
    },
    {
      accessorKey: 'reach',
      header: t<string>('HeaderColumn.Reach'),
      meta: { align: 'right', help: t<string>('Tooltip.ReachPostHelp'), sortField: InstagramStoryPostSortField.REACH },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.reach)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Reply'),
      meta: { align: 'right', help: t<string>('Tooltip.CommentHelp'), sortField: InstagramStoryPostSortField.COMMENT },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'tapsForward',
      header: t<string>('HeaderColumn.Tap Forward'),
      meta: {
        align: 'right',
        help: t<string>('Tooltip.TapForward'),
        sortField: InstagramStoryPostSortField.TAPS_FORWARD
      },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.tapsForward)} />
    },
    {
      accessorKey: 'swipeForward',
      header: t<string>('HeaderColumn.Swipe Forward'),
      meta: {
        align: 'right',
        help: t<string>('Tooltip.SwipeForward'),
        sortField: InstagramStoryPostSortField.SWIPE_FORWARD
      },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.swipeForward)} />
    },
    {
      accessorKey: 'tapsBack',
      header: t<string>('HeaderColumn.Tap Back'),
      meta: { align: 'right', help: t<string>('Tooltip.TapBack'), sortField: InstagramStoryPostSortField.TAPS_BACK },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.tapsBack)} />
    },
    {
      accessorKey: 'exits',
      header: t<string>('HeaderColumn.Exits'),
      meta: { align: 'right', help: t<string>('Tooltip.ExitsHelp'), sortField: InstagramStoryPostSortField.EXITS },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.exits)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { help: t<string>('Tooltip.PostDateHelp'), sortField: InstagramStoryPostSortField.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
